import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid } from "@material-ui/core";
import CardArt from "./CardArt";
import SongFavorite from "../parts/SongFavorite";
import { Link } from "react-router-dom";

import BanRemove from "../parts/BanRemove";
import { playerStoreContext } from "lib/player_store";
const VideoCard = ({
  song_id,
  favorite,
  image,
  title,
  youtubeId,
  artist,
  musicPath,
  songPath,
  removeHandler,
  favoriteHandler
}) => {
  const store = useContext(playerStoreContext);

  const setYoutubeID = () => {
    if (youtubeId) {
      store.setYoutubeID(youtubeId);
    } else {
      return false;
    }
  };

  return (
    <div className="card video-card">
      <Grid container spacing={0} alignItems="center">
        <Grid item xs={4}>
          <div className="play-hover-container" onClick={setYoutubeID}>

            <CardArt image={image} aspectRatio="320/180" />
            {youtubeId && (
              <div className="play-hover">
                <FontAwesomeIcon icon="play-circle" />
              </div>
            )}
          </div>
        </Grid>
        <Grid item xs>
          <div className="card-inner">
            {songPath ? (
              <div
                className="click-underline"
                style={{ clear: "both", float: "left" }}
              >
                <Link to={songPath} title={`Go to ${title} video`}>
                  {title}
                </Link>
              </div>
            ) : (
              <div>{title}</div>
            )}
            {musicPath ? (
              <div
                className="click-underline"
                style={{ clear: "both", float: "left" }}
              >
                <Link to={musicPath} title={`Go to ${artist}`}>
                  {artist}
                </Link>
              </div>
            ) : (
              <div className="click-underline">{artist}</div>
            )}
          </div>
        </Grid>
        <Grid item className="heart">
          {removeHandler ? (
            <BanRemove song_id={song_id} removeHandler={removeHandler} />
          ) : (
            <SongFavorite song_id={song_id} favorite={favorite} callback={favoriteHandler} />
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default VideoCard;
